<template>
  <div>
    <h4>Sub Formulário:</h4>
    <!-- {{ subForm }} -->

    <b-form-group label="Nome" label-for="input-form-name" class="mb-4">
      <b-form-input
        id="input-form-name"
        type="text"
        v-model="subForm.title"
        required
        placeholder="Insira o nome para o subformulário"
      ></b-form-input>
    </b-form-group>

    <table-form-fields
      :items="subForm.fields"
      :allow-add-fields="true"
      :company-options="options"
      :options-profiles="optionsProfiles"
      :profiles="profiles"
      :userMaster="true"
      class="mb-4"
    ></table-form-fields>
  </div>
</template>
<script>
export default {
  name: "SubFormConfig",
  props: {
    subForm: Object,
    companyOptions: Array,
    optionsProfiles: Array,
    profiles: Array,
  },
  components: {
    TableFormFields: () =>
      import("@/components_rms/checklist/form/TableFormFields.vue"),
  },
  data() {
    return {
      optionsList: [],
    };
  },
  computed: {
    options() {
      for (let i = 0; i < this.companyOptions.length; i++) {
        const opt = this.companyOptions[i];
        if (opt.value == 22) {
          continue;
        }
        this.optionsList.push(opt);
      }
      console.log(this.optionsList)
      return this.optionsList;
    },
  },
};
</script>
